<template>
  <div>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="form-npa law-page">
        <div class="position">
          <div class="bg-white p-20">
            <div class="form-head">
              <Widget position="menu_profile"/>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile"/>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="law_statistic-details-title">
              <div class="title">
                {{ getTypeTransName(type) }}
              </div>
              <div class="upload">
                <img src="@/assets/icons/excel.png" />
                <a :href="baseUrl + data.uploadFile">{{ $t('Скачать') }}</a>
              </div>
            </div>
            <div v-if="data && changeSort">
                <!------>
                <div
                  class="sort_select"
                  v-if="pieTypes.includes(type)"
                >
                  <label
                    class="sort_label"
                  >
                    {{ $t('Год') }}:
                  </label>
                  <v-select
                    :items="years"
                    :placeholder="$t('Год')"
                    v-model="params.year"
                    @change="changeByYear"
                      outlined
                      dense
                      clearable
                  />
                </div>
                <!------->
                <div
                  class="sort"
                  v-if="yearTypes.includes(type)"
                >
                  <label
                    class="sort_label"
                  >
                    {{ $t('Выберите период') }}:
                  </label>
                  <div class="sort_select">
                    <label
                      class="sort_label"
                    >
                      {{ $t('От') }}:
                    </label>
                    <v-select
                    :items="years"
                    :placeholder="$t('Тип обращения')"
                    v-model="sortData.first"
                      outlined
                      dense
                      clearable
                    />
                  </div>
                  <div class="sort_select">
                    <label
                      class="sort_label"
                    >
                      {{ $t('До') }}:
                    </label>
                    <v-select
                      :items="years"
                      :placeholder="$t('Тип обращения')"
                      v-model="sortData.second"
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </div>
             <PrintPage
               text="Получить в формате PDF"
             >
              <div
                class="law_statistic-details"
              >
                  <LawStatisitcDetailsYearTable
                    v-if="yearTypes.includes(type)"
                    :data="sortingInData "
                  />
                  <LawStatisitcDetailsPieTable
                    v-if="pieTypes.includes(type)"
                    :data="data.items"
                  />

                  <LawStatisitcDetailsPieTable
                    v-if="type == 'acceptedRejectedNorms'"
                    @change-year-graphic="changeYearGraphic"
                    :data="data.items"
                    :accepted-rejected-norms="true"
                  />

                  <div
                    v-if="graphData != null"
                    class="law_statistic-details-graph"
                  >
                    <LawStatisticGraphicCustom
                      v-if="graphType == 'line'"
                      :received-data="graphData"
                      :graphType="graphType"
                      id="year"
                      :data-labels="true"
                      :maintain-aspect-ratio="true"
                      :aspectRatio="2"
                    />

                    <AcceptedRejectedNormsModal
                        v-if="isAcceptedRejectedNorms"
                        :item="acceptedRejectedNormsItem"
                    />

                    <GraphicCustomPie
                      v-if="graphType == 'pie'"
                      :data="data.items"
                    />
                  </div>
              </div>
             </PrintPage>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>

import {Trans} from "@/plugins/Translation"
import Widget from '@/components/app/Widget'
import LAW from '@/model/law'
import STATISTIC from '@/model/statistic.js'
import LawStatisticGraphicCustom from '@/components/law/LawStatisticGraphicCustom.vue'
import LawStatisitcDetailsYearTable from '@/components/law/LawStatisitcDetailsYearTable.vue'
import LawStatisitcDetailsPieTable  from '@/components/law/LawStatisitcDetailsPieTable.vue'
import GraphicCustomPie from '@/components/law/GraphicCustomPie.vue'
import { mapMutations } from "vuex"
import AcceptedRejectedNormsModal from '@/components/law/AcceptedRejectedNormsModal.vue'
import PrintPage from '../components/widget/PrintPage.vue';

export default {
  name: 'LawStatistic',
  components: {
    Widget,
    LawStatisticGraphicCustom,
    LawStatisitcDetailsYearTable,
    LawStatisitcDetailsPieTable,
    GraphicCustomPie,
    AcceptedRejectedNormsModal,
    PrintPage
  },
  data () {
    return {
      data: null,
      changeSort: true,
      list: null,
      acceptedRejectedNormsItem: null,
      isAcceptedRejectedNorms: false,
      params: {},
      sortData: {
        first: '1990',
        second: '2030'
      },
      yearTypes: ["year", "norms", 'developers'],
      pieTypes: ["type", 'status', 'byLawTypes'],
      years: [
        "1990",
        "1991",
        "1992",
        "1993",
        "1994",
        "1995",
        "1996",
        "1997",
        "1998",
        "1999",
        "2000",
        "2001",
        "2002",
        "2003",
        "2004",
        "2005",
        "2006",
        "2007",
        "2008",
        "2009",
        "2010",
        "2011",
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030"
      ]
    }
  },

  mounted () {
    this.fetchData()
  },
  watch: {
    sortData: {
      deep: true,
      handler () {
        this.changeSort = false
        this.$nextTick(() => {
          this.changeSort = true
        })
      }
    }
  },

  computed: {
    graphType () {
      if (this.yearTypes.includes(this.type)) {
        return 'line'
      }

      if (this.pieTypes.includes(this.type) || this.type == 'acceptedRejectedNorms') {
        return 'pie'
      }

      return 'bar'
    },

    sortingInData () {
      return this.data.items.filter(item => item.year >= this.sortData.first && item.year <= this.sortData.second)
    },

    baseUrl () {
      let baseUrl = process.env.VUE_APP_BACK_URL
      return baseUrl.substring(0, baseUrl.length - 1)
    },

    graphData () {
      if (this.type == 'year') {
        return STATISTIC.year(this.sortingInData)
      }

      if (this.type == 'norms') {
        return STATISTIC.norms(this.sortingInData)
      }

      if (this.type == 'developers') {
        return STATISTIC.developers(this.sortingInData)
      }

      return []
    },

    type () {
      return this.$route.params.type
    },
    breadcrumbs () {
      if (this.list) {
        return [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Исполнение законов'), disabled: false, href:Trans.currentLocaleUrl + '/law'},
          {text: this.$i18n.t('Статистика'), disabled: false, href:Trans.currentLocaleUrl + '/law/statistic' },
          {text: this.getTypeTransName(this.type), disabled: true }
        ]
      }

      return []
    },


  },
  methods: {
    ...mapMutations(['setLoading']),
    changeYearGraphic (item) {
      this.changeSort = false
      this.isAcceptedRejectedNorms = true
      this.acceptedRejectedNormsItem = item
      this.$nextTick(() => {
        this.changeSort = true
      })
    },
    changeByYear () {
      this.fetchData()
    },

    fetchData() {
      this.setLoading(true)
      this.list = null
      LAW.getStatisticDataByType(this.type, this.params).then((response) => {
        this.data = response.data
        this.data.items = this.data.items.sort((a, b) => a.year - b.year)
        LAW.getStatisticList().then((response) => {
          this.list = response.data.downloadLinks
          this.setLoading(false)
          this.changeSort = false
          this.$nextTick(() => {
            this.changeSort = true
          })
        }).catch((error) => {
          this.setLoading(false)
        })
      }).catch((error) => {
        this.setLoading(false)
      })
    },

    getTypeTransName (type) {
      console.log(this.list)
      if (!this.list) {
        return ''
      }

      let findType = this.list.find(item => item.id == type);
      return findType ? findType.transName : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .law_statistic-details {
    display: flex;
    padding-bottom: 50px;

    &-graph {
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    &-title {
      padding-bottom: 20px;
      display: flex;
      align-items: center;


      .upload {
        padding-left: 120px;
        height: 40px;
        display: flex;
        align-items: center;

        a {
          color: #333;
          text-decoration: underline;
        }

        img {
          width: 24px;
          margin-right: 10px;
        }
      }
    }
  }

  .sort {
    margin-bottom: 40px;
    &_label {
      padding-right: 10px;
      font-weight: 500;
    }

    &_select {
      margin-top: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .v-input {
        max-width: 300px;
      }
    }
  }
</style>
